import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noProductsScanned: {
    defaultMessage: 'Scan your first product to begin adding it to your inventory.',
    id: 'lRBy35',
    description: 'Title when table is empty',
  },
});
